export default "__VITE_ASSET__7uQjjO3hz61BTD3uZte2zg__"